export default __webpack_public_path__ + "static/media/BSTN.9e5d720c.svg";